import { Trans } from "@lingui/react/macro"
import { IconHash } from "@tabler/icons-react"
import { TopicChips } from "../../../TopicChips"
import classes from "../../styles.module.css"
import type { IProps } from "./interfaces"

/**
 * TopicsCard renders the analyser's topic list as a chip cloud via the shared
 * TopicChips component (also used by the meeting-list cards, so the two stay
 * in sync).
 */
export function TopicsCard({ topics }: IProps): React.JSX.Element | null {
  if (!topics || topics.length === 0) return null
  return (
    <section className={classes.card}>
      <div className={classes.cardHead}>
        <h2 className={classes.cardTitle}>
          <IconHash size={16} />
          <Trans>Topics</Trans>
        </h2>
      </div>
      <TopicChips topics={topics} />
    </section>
  )
}
